import Model from '@/models/Model.js';

export default class TermScheduleGroup extends Model {
    static entity = 'term_schedule_group';

    static modelName = 'TermScheduleGroup';

    static primaryKey = ['term_schedule_id', 'group_id'];

    static fields() {
        return {
            id: this.attr(),
            term_schedule_id: this.attr(null),
            group_id: this.attr(null),

            ...super.fields(),

            term_schedule: this.belongsTo('term_schedules', 'term_schedule_id'),
            group: this.belongsTo('groups', 'group_id'),
        };
    }
}
